var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a1 1 0 0 1 1 1v11.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 1.414-1.414L7 12.586V1a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
};

export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAwQzguNTUyMjggMCA5IDAuNDQ3NzE1IDkgMVYxMi41ODU4TDE0LjI5MjkgNy4yOTI4OUMxNC42ODM0IDYuOTAyMzcgMTUuMzE2NiA2LjkwMjM3IDE1LjcwNzEgNy4yOTI4OUMxNi4wOTc2IDcuNjgzNDIgMTYuMDk3NiA4LjMxNjU4IDE1LjcwNzEgOC43MDcxMUw4LjcwNzExIDE1LjcwNzFDOC4zMTY1OCAxNi4wOTc2IDcuNjgzNDIgMTYuMDk3NiA3LjI5Mjg5IDE1LjcwNzFMMC4yOTI4OTMgOC43MDcxMUMtMC4wOTc2MzExIDguMzE2NTggLTAuMDk3NjMxMSA3LjY4MzQyIDAuMjkyODkzIDcuMjkyODlDMC42ODM0MTcgNi45MDIzNyAxLjMxNjU4IDYuOTAyMzcgMS43MDcxMSA3LjI5Mjg5TDcgMTIuNTg1OFYxQzcgMC40NDc3MTUgNy40NDc3MiAwIDggMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";